import { render, staticRenderFns } from "./ColleaguesView.vue?vue&type=template&id=47ebf642&scoped=true&"
import script from "./ColleaguesView.vue?vue&type=script&lang=js&"
export * from "./ColleaguesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ebf642",
  null
  
)

export default component.exports